import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { SectionLayoutMetadataBase } from '../../model/dyn-form/form-metadata/layout/section-layout.model';
import { FormlyFieldConfigFactory, FormlyFieldConfigRegistry, FormView, SectionLayoutFormlyFieldGroup } from '../../model/dyn-form/form-visualizer/formly-group.model';
import { EFormWebServiceService } from '../../services/eform/e-form-webservice.service';
import { FormInstanceController } from './form-instance-controller.model';

@Component({
    selector: 'app-form-instance',
    templateUrl: './form-instance.component.html',
    styleUrl: './form-instance.component.scss',
    standalone: true,
    imports: [
        CommonModule, 
        FormlyModule, FormlyMaterialModule, FormlyMatDatepickerModule,
        ReactiveFormsModule, FormsModule
    ],
})
export class FormInstanceComponent implements OnInit {

    @Input()
    controller: FormInstanceController | null = null

    @Input()
    section: SectionLayoutMetadataBase | null = null

    @Input()
    customData: Map<string, any> | null = null

    sectionView!: SectionLayoutFormlyFieldGroup
    formlyRegistry: FormlyFieldConfigRegistry 
    formlyFactory: FormlyFieldConfigFactory

    fv: FormView | null = null

    constructor(protected eFormWebServiceService: EFormWebServiceService) {
        this.formlyRegistry = new FormlyFieldConfigRegistry(this.eFormWebServiceService)
        this.formlyFactory = new FormlyFieldConfigFactory(this.formlyRegistry)
    }

    ngOnInit(): void {
        if (this.section == null) {
            console.log("The section is null :) ")
            return
        }

        if (this.customData != null) {
            this.formlyRegistry.setCustomDataWebService(this.customData)
        }

        this.sectionView = new SectionLayoutFormlyFieldGroup(<SectionLayoutMetadataBase>this.section, this.formlyFactory, /*'form-editor'*/'form-dyn-runtime')

        this.fv = new FormView(this.sectionView)
        this.fv.fields.push(this.sectionView)
        if (this.controller) {
            this.controller.register(this.fv)
        }

    }

}
